// extracted by mini-css-extract-plugin
export default {"dialog__content":"ScanSetupModals_dialog__content__QzwtL"};